const USER_DATA = "userData";

export const saveClientFacilityState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(USER_DATA, serializedState);
  } catch (err) {
    console.error("Error saving clientFacilityState:", err);
  }
};

export const loadClientFacilityState = () => {
  try {
    const serializedState = localStorage.getItem(USER_DATA);
    return serializedState ? JSON.parse(serializedState) : { client: null, facility: null };
  } catch (err) {
    console.error("Error loading clientFacilityState:", err);
    return { client: null, facility: null };
  }
};
